define ['./income.scss'], () ->
  ($scope, $state, $stateParams, $rootScope, $http, RENTAPPLICATION_API_URL, $uibModal, Application) ->
    $scope.application = Application.get id: $stateParams.application_id
    $scope.application_id = $stateParams.application_id
    $scope.connect_url = ""
    $scope.is_loading = false
    
    $scope.open_skip_modal = () ->
      $uibModal.open
        template: require("./skip_modal.jade")
        controller: require("./skip_modal.coffee")
        windowClass: 'skip-modal'
        scope: $scope
        backdrop: 'static'
        keyboard: false
      .result
      .then((result) -> 
        if result
          if $state.current.name == 'root.payment.income'
            if !_.find($scope.application.reports, (o) -> o.status == 'sent_payment_request')
              $state.go("root.payment.complete")
            else
              $state.go("root.payment.pay")
          else
            $state.go("root.applications.pay", { application: $scope.application, application_id: $scope.application_id})
      )
    
    $scope.open_finicity_connect_modal = () ->
      $uibModal.open
        template: require("./finicity_connect_modal.jade")
        controller: require("./finicity_connect_modal.coffee")
        windowClass: 'finicity-connect'
        scope: $scope
        backdrop: 'static'
        keyboard: false
      .result
      .then((result) -> 
        if result
          # If applicant is going through request for payment flow
          if $state.current.name == 'root.payment.income'
            if !_.find($scope.application.reports, (o) -> o.status == 'sent_payment_request')
              $state.go("root.payment.complete")
            else
              $state.go("root.payment.pay")
          if $scope.application.price > 0 and !$scope.application.is_paid
            $state.go("root.applications.pay", { application: $scope.application, application_id: $scope.application_id})
          else
            $state.go("root.applications.apply_success", { paid: true, application_id: response.data.id, application: response.data })
      )
      
      
    $scope.get_finicity_connect_url = () ->
      $scope.is_loading = true
      $http.post("#{RENTAPPLICATION_API_URL}/api/v3/applications/#{$scope.application_id}/generate_finicity_connect_url/")
        .then((resp) -> 
          $scope.connect_url = resp.data.connect_url
          $scope.open_finicity_connect_modal()
        )
        .catch((err) ->
          if err.data.message 
            if err.data.message.indexOf("Missing fields") >= 0
              $scope.error_message = "#{err.data.message}. Please return to application form to enter required information."
            else
              $scope.error_message = err.data.message
          else
            $scope.error_message = "Error has occurred. Please contact support@rentapplication.net."
        )
        .finally ->
          $scope.is_loading = false


    $scope.open_link_bank_account_modal = () ->
      $scope.get_finicity_connect_url()
    


// WEBPACK FOOTER //
// ./components/applications/income/income.coffee